const { createContext } = require("react");


const CatalogsContext = createContext({
  paymentOptions: [],
  countries: [],
  contactTypes: [],
  currencies: [],
});

export default CatalogsContext;